import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { FileText, Download, Loader2 } from 'lucide-react';
import { axios, auth, errMsg, mbUrl, muted, primary, toast } from './mbApi';

export const TEMPLATE_URL = '/templates/Template-Brief-Marketing-Hub.docx';

export const PdfImport = ({ ibId, onFilled }) => {
  const [url, setUrl] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const read = async () => {
    setBusy(true);
    setErr('');
    try {
      const { data } = await axios.post(mbUrl(ibId, '/brief-from-pdf'), { url: url.trim() }, auth());
      onFilled(data.fields, data.source_url, data.images, data.warnings);
      toast.success(`Brief diisi dari PDF (${(data.images || []).length} gambar) — ruangan yang anda dah isi tak ditimpa. Semak dulu sebelum simpan.`);
    } catch (e) {
      setErr(errMsg(e, 'Gagal baca PDF'));
    } finally { setBusy(false); }
  };
  return (
    <div className="rounded-lg border border-dashed border-[hsl(var(--border))] p-3 space-y-2" data-testid="mb-pdf-import">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className={`text-xs font-semibold ${primary} flex items-center gap-1.5`}><FileText size={14} className="text-[#F77F00]" /> Isi dari PDF (link PDF / Google Drive / Google Docs)</p>
        <a href={TEMPLATE_URL} download className="text-[11px] text-[#F77F00] underline flex items-center gap-1" data-testid="mb-pdf-template-download">
          <Download size={12} /> Muat turun template brief
        </a>
      </div>
      <div className="flex flex-col sm:flex-row gap-2">
        <Input value={url} onChange={(e) => setUrl(e.target.value)} placeholder="https://drive.google.com/file/d/…/view" className="flex-1" data-testid="mb-pdf-url" />
        <Button variant="outline" disabled={busy || !url.trim().startsWith('https://')} onClick={read} data-testid="mb-pdf-read">
          {busy ? <><Loader2 size={14} className="mr-1.5 animate-spin" /> AI sedang baca…</> : 'Baca PDF'}
        </Button>
      </div>
      {err && <p className="text-[11px] text-red-400" data-testid="mb-pdf-error">{err}</p>}
      <p className={`text-[10px] ${muted}`}>Share fail sebagai &quot;Anyone with the link&quot; (Viewer). AI isi borang di bawah tanpa simpan apa-apa — Kaer WAJIB semak sebelum Simpan draf / Sedia untuk diserah. Kod brief keluar automatik selepas disimpan.</p>
    </div>
  );
};
